import {
  SET_PP_GAME_NAMES,
  SET_PP_GAME_IMAGES,
  SET_PP_GAME_POLA,
  SET_GAME_ISLOADING,
  SET_GAME_ISERROR
} from '../actionTypes';

const initialState = {
  ppNames: [],
  ppImages: [],
  pragmaticPolas: [],
  nameAndImagesIsLoading: true,
  isError: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PP_GAME_NAMES:
      return { ...state, ppNames: action.payload }
    case SET_PP_GAME_IMAGES:
      return { ...state, ppImages: action.payload };
    case SET_PP_GAME_POLA:
      return { ...state, pragmaticPolas: action.payload };
    case SET_GAME_ISLOADING:
      return { ...state, nameAndImagesIsLoading: action.payload };
    case SET_GAME_ISERROR:
      return { ...state, isError: action.payload };
    default:
      return state;
  };
};

export default reducer;